export default "__VITE_ASSET__cf1cb86c__"